import { Box, HStack } from "@chakra-ui/react";
import { useRouter } from "next/router";
import { colors, ColorIcon, customEvent, Spacing } from "goi_common";
import { baseColors } from "goi_common/src/design-system";

/**
 * 4-way ③ 진입 카드형 CTA: "장례 총 비용 확인하기" → /match/region-cost.
 * 조건에 맞는 장례식장·장지·화장장 총 비용을 한 번에 견적받는 스텝 퍼널로 연결.
 *
 * emphasis:
 * - primary: 오렌지 채움 (가족장/일반장 service의 MAIN)
 * - subtle: 흰 배경 + 테두리 (시도/시군구의 sub1)
 */
interface RegionCostCardProps {
  sido: string;
  sigungu?: string;
  emphasis?: "primary" | "subtle";
}

function RegionCostCard({ sido, sigungu, emphasis = "subtle" }: RegionCostCardProps) {
  const router = useRouter();
  const isPrimary = emphasis === "primary";

  const onClick = () => {
    customEvent({
      newGtm: { path: "parlor_region", trigger_and_target: "hub_cost-uv_rgn_cost" },
    });
    const params = new URLSearchParams();
    if (sido) params.set("sido", sido);
    if (sigungu) params.set("sigungu", sigungu);
    const query = params.toString();
    router.push(query ? `/match/region-cost/?${query}` : "/match/region-cost/");
  };

  const titleColor = isPrimary ? "#fff" : baseColors.label_normal;
  const descColor = isPrimary ? "rgba(255,255,255,0.85)" : baseColors.label_assistive_2;

  return (
    <Box
      as="button"
      textAlign="left"
      cursor="pointer"
      width="100%"
      display="flex"
      alignItems="center"
      gap="14px"
      padding="18px"
      borderRadius="16px"
      background={isPrimary ? baseColors.orange_500 : baseColors.background_normal}
      border={isPrimary ? "none" : `1px solid ${baseColors.line_normal}`}
      onClick={onClick}
    >
      <Box flexShrink={0} display="flex" alignItems="center">
        <ColorIcon
          name="icon-coin-mono"
          color={isPrimary ? colors.white : colors.orange650}
          size={28}
        />
      </Box>
      <Box flex={1}>
        <Box className="body_1_normal_sb" color={titleColor} wordBreak="keep-all">
          내 조건에 맞는 장례 총 비용 확인하기
        </Box>
        <Spacing gap={4} />
        <Box className="label_1_r" color={descColor} wordBreak="keep-all">
          장례식장, 장지, 화장장을 포함한 장례 전체 비용을 확인해보세요.
        </Box>
      </Box>
      <HStack flexShrink={0}>
        <Box
          className="body_2_normal_sb"
          color={isPrimary ? "#fff" : baseColors.orange_600}
          whiteSpace="nowrap"
        >
          확인 →
        </Box>
      </HStack>
    </Box>
  );
}

export default RegionCostCard;
